<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading..."></mat-progress-bar>
</section>

<div class="firm-edit-dialog" [ngStyle]="{'--entity-color' : uiData.individual.color}" *ngIf="!loading && individual">
  <mat-card [style.background-color]="uiData.individual.color">
    <h2 class="noMarginHeader">
      <mat-icon>{{uiData.individual.icon}}</mat-icon> {{ individual.firstName + ' ' + individual.lastName }}
    </h2>
  </mat-card>

  <div class="scroll-container">
    <br />
    <div fxLayout="column">
      <mat-card>
        <mat-tab-group dynamicHeight mat-align-tabs="center" mat-stretch-tabs="true" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="selectedTabIndex = $event">
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>person</mat-icon> &nbsp; Individual Information
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div>
                    <span fxFlex>Individual Information</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column" fxLayoutGap="8px">
                    <form [formGroup]="personForm">
                      <div fxLayout="column" fxLayoutGap="8px">
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                          <mat-form-field fxFlex="100%">
                            <input matInput placeholder="Title" formControlName="title">
                          </mat-form-field>
                          <mat-form-field fxFlex="100%">
                            <input matInput placeholder="First Name" formControlName="firstName">
                          </mat-form-field>
                          <mat-form-field fxFlex="100%">
                            <input matInput placeholder="Middle Name" formControlName="middleName">
                          </mat-form-field>
                          <mat-form-field fxFlex="100%">
                            <input matInput placeholder="Last Name" formControlName="lastName">
                          </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                          <div fxFlex="50" fxLayout="column" fxLayoutGap="8px">
                            <span><strong>Public Listing</strong></span>
                            <mat-checkbox class="mat-checkbox" [checked]="personForm.get('response')?.value === 'Yes'" (change)="updateResponse($event)">
                              Check to publish this individual on the website.
                            </mat-checkbox>
                          </div>
                          <div fxFlex="50" fxLayout="column" fxLayoutGap="8px" *ngIf="false">
                            <span><strong>Inactive</strong></span>
                            <mat-checkbox class="mat-checkbox" formControlName="inactive">
                              Set this individual status Inactive/Active.
                            </mat-checkbox>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.contact.icon}}</mat-icon> &nbsp; Contact Information({{addressTableData.length + contactInformationTableData.length}})
            </ng-template>
            <ng-container>
              <div fxLayout="row" fxLayout.lt-md="column" fxFlex>
                <mat-card class="custom-mat-card" fxFlex="100">
                  <mat-accordion multi>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span><h4>Addresses - {{addressTableData.length}}</h4></span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="column">
                        <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                            <div fxLayoutGap="5px">
                              <strong class="noMarginHeader">Results ({{addressFilteredTableData.length}})</strong>
                              <mat-form-field style="width:200px;">
                                <input (keyup)="filterAddressTable()" placeholder="Filter Results" [(ngModel)]="filterAddressString" [ngModelOptions]="{standalone: true}" matInput />
                              </mat-form-field>
                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Address Type" [formControl]="filterAddressType" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressTypeList" [value]="type">{{ type }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Physical" [formControl]="filterAddressPhysical" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressBoolList" [value]="type">{{ type }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Mailing" [formControl]="filterAddressMailing" (selectionChange)="filterAddressTable()">
                                  <mat-option *ngFor="let type of addressBoolList" [value]="type">{{ type }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div>
                              <button mat-raised-button color="primary" (click)="editAddressTableEntry(null)">
                                <mat-icon>add</mat-icon> Add Address
                              </button>
                            </div>
                          </div>

                          <br />

                          <mat-table [dataSource]="addressDataSource" matSort #AddressTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                            <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="addressTableColumns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: addressTableColumns" (click)="editAddressTableEntry(row); $event.stopPropagation()"></mat-row>
                            <ng-container *ngFor="let cellData of addressTableFormat" [matColumnDef]="cellData.columnName">
                              <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                              <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                                <ng-container [ngSwitch]="cellData.type">
                                  <ng-container *ngSwitchCase="'date'">
                                    {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
                                  </ng-container>
                                  <ng-container *ngSwitchCase="'bool'">
                                    <mat-checkbox [checked]="row[cellData.columnName]" (click)="$event.stopPropagation()" (change)="addressCheckboxChange(row, cellData.columnName)"></mat-checkbox>
                                  </ng-container>
                                  <ng-container *ngSwitchDefault>
                                    {{ displayLimit(row[cellData.columnName], cellData.size) }}
                                  </ng-container>
                                </ng-container>
                              </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                              <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                              <mat-cell *matCellDef="let row" fxFlex="7">
                                <div style="display: flex; justify-content: space-between; width: 100px;">
                                  <button mat-icon-button color="primary" style="width: 50px;" aria-label="Edit address" matTooltip="Edit address" (click)="editAddressTableEntry(row); $event.stopPropagation()">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                </div>
                              </mat-cell>
                            </ng-container>
                          </mat-table>

                          <br />
                          <mat-paginator [pageSize]="addressTablePageSize" [pageSizeOptions]="[5, 10, 50, addressFilteredTableData.length]" #AddressTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                        </div>
                      </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <span><h4>Contact Information - {{contactInformationTableData.length}}</h4></span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div fxLayout="column">
                        <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                            <div fxLayoutGap="5px">
                              <strong class="noMarginHeader">Results ({{contactInformationFilteredTableData.length}})</strong>
                              <mat-form-field style="width:200px;">
                                <input (keyup)="filterContactInformationTable()" placeholder="Filter Results" [(ngModel)]="filterContactInformationString" [ngModelOptions]="{standalone: true}" matInput />
                              </mat-form-field>
                              <mat-form-field style="width:150px">
                                <mat-select multiple placeholder="Filter Contact Type" [formControl]="filterContactInformationType" (selectionChange)="filterContactInformationTable()">
                                  <mat-option *ngFor="let type of contactInformationTypeList" [value]="type">{{ type }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div>
                              <button mat-raised-button color="primary" (click)="editContactInformationTableEntry(null)">
                                <mat-icon>add</mat-icon> Add Contact Information
                              </button>
                            </div>
                          </div>

                          <br />

                          <mat-table [dataSource]="contactInformationDataSource" matSort #ContactInformationTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                            <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="contactInformationTableColumns"></mat-header-row>
                            <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: contactInformationTableColumns" (click)="editContactInformationTableEntry(row); $event.stopPropagation()"></mat-row>
                            <ng-container *ngFor="let cellData of contactInformationTableFormat" [matColumnDef]="cellData.columnName">
                              <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                              <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                                {{ displayLimit(row[cellData.columnName], cellData.size) }}
                              </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                              <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                              <mat-cell *matCellDef="let row" fxFlex="7">
                                <div style="display: flex; justify-content: space-between; width: 100px;">
                                  <button mat-icon-button color="primary" style="width: 50px;" aria-label="Edit contact information" matTooltip="Edit contact information" (click)="editContactInformationTableEntry(row); $event.stopPropagation()">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                </div>
                              </mat-cell>
                            </ng-container>
                          </mat-table>

                          <br />
                          <mat-paginator [pageSize]="contactInformationTablePageSize" [pageSizeOptions]="[5, 10, 50, contactInformationFilteredTableData.length]" #ContactInformationTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </mat-card>
              </div>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.certificate.icon}}</mat-icon> &nbsp; Certificates ({{personFilteredCertificates.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <span fxFlex>Certificates</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayout="column">
                          <strong class="noMarginHeader">Results ({{personFilteredCertificates.length}})</strong>
                          <div fxLayout="row" fxLayout.lt-md="column">
                            <mat-form-field style="width:200px;">
                              <input placeholder="Filter Certificates" type="text" [(ngModel)]="certificateFilterString" [ngModelOptions]="{standalone: true}" (input)="filterCertificateTable()" matInput />
                            </mat-form-field>
                            &nbsp;&nbsp;
                            <mat-form-field style="width:200px;">
                              <mat-label>Filter Certificate Stage</mat-label>
                              <mat-select (selectionChange)="filterCertificateTable()" [formControl]="certificateStageFilter">
                                <mat-option value="Initial">Initial</mat-option>
                                <mat-option value="Refresher">Refresher</mat-option>
                                <mat-option value="Both">Both</mat-option>
                              </mat-select>
                            </mat-form-field>
                            &nbsp;&nbsp;
                            <mat-checkbox [(ngModel)]="showHistory" [ngModelOptions]="{standalone: true}" (change)="filterCertificateTable()">Show Historical</mat-checkbox>
                          </div>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="certificatesDataSource" matSort #CertificateTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="certificateTable.layout.columns.concat('actions')"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: certificateTable.layout.columns.concat('actions')" (click)="openCertificateAction(row); $event.stopPropagation()" [ngStyle]="{'--hover-bg-color': sharedService.hoverBackgroundColor}"></mat-row>
                        <ng-container *ngFor="let cellData of certificateTable.layout.container" [matColumnDef]="cellData.columnName">
                          <mat-header-cell [fxFlex]="cellData.size" mat-sort-header *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                            <ng-container [ngSwitch]="cellData.type">
                              <ng-container *ngSwitchCase="'date'">
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                  <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                </div>
                                <div *ngIf="!isMobile">{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <div *ngIf="isMobile" fxLayout="row">
                                  <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                                  <span>{{ displayLimit(row[cellData.columnName], cellData.size) }}</span>
                                </div>
                                <div *ngIf="!isMobile">{{displayLimit(row[cellData.columnName], cellData.size)}}</div>
                              </ng-container>
                            </ng-container>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                          <mat-header-cell fxFlex="12" *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Actions</mat-header-cell>
                          <mat-cell fxFlex="12" *matCellDef="let row" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
                            <div *ngIf="isMobile" fxLayoutGap="2px" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
                              <span><strong>Action: </strong></span> &nbsp;&nbsp;
                              <button mat-raised-button color="primary" style="width: 70px;" [attr.aria-label]="getCertificateActionLabel(row) + ' certificate'" [matTooltip]="getCertificateActionLabel(row) + ' certificate'" (click)="openCertificateAction(row); $event.stopPropagation()">{{ getCertificateActionLabel(row) }}</button>
                            </div>
                            <div fxLayout="row" fxLayoutGap="2px" *ngIf="!isMobile">
                              <button mat-raised-button color="primary" style="width: 70px; padding: 1px;" [attr.aria-label]="getCertificateActionLabel(row) + ' certificate'" [matTooltip]="getCertificateActionLabel(row) + ' certificate'" (click)="openCertificateAction(row); $event.stopPropagation()">{{ getCertificateActionLabel(row) }}</button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="certificateTablePageSize" [pageSizeOptions]="[5, 10, 50, personFilteredCertificates.length]" #CertificateTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>description</mat-icon> &nbsp; Applications ({{visibleApplicationCount}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row">
                    <span fxFlex>Applications</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <app-individual-application-list [personId]="individual.id" [isEmbedded]="true" (countChanged)="onApplicationCountChanged($event)"></app-individual-application-list>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.testing.icon}}</mat-icon> &nbsp; Testing ({{testingFilteredTableData.length}})
            </ng-template>
            <ng-container>
              <mat-card>
                <mat-card-title>
                  <div fxLayout="row"><span>Testing Records</span></div>
                </mat-card-title>
                <mat-card-content>
                  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                      <div>
                        <strong class="noMarginHeader">Results ({{testingFilteredTableData.length}})</strong>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-form-field style="width:200px;">
                          <input (keyup)="filterTestingTable()" placeholder="Filter Results" [(ngModel)]="testingFilterString" [ngModelOptions]="{standalone: true}" matInput />
                        </mat-form-field>
                      </div>
                    </div>
                    <br />
                    <mat-table [dataSource]="testingDataSource" matSort #TestingTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                      <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="testingTableColumns"></mat-header-row>
                      <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: testingTableColumns"></mat-row>
                      <ng-container *ngFor="let cellData of testingTableFormat" [matColumnDef]="cellData.columnName">
                        <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size">{{ cellData.type === 'date' ? (row[cellData.columnName] | date:'MM/dd/yyyy') : displayLimit(row[cellData.columnName], '80') }}</mat-cell>
                      </ng-container>
                    </mat-table>
                    <br />
                    <mat-paginator [pageSize]="testingTablePageSize" [pageSizeOptions]="[5, 10, 50, testingFilteredTableData.length]" #TestingTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.training.icon}}</mat-icon> &nbsp; Training ({{trainingFilteredTableData.length}})
            </ng-template>
            <ng-container>
              <mat-card>
                <mat-card-title>
                  <div fxLayout="row"><span>Training Records</span></div>
                </mat-card-title>
                <mat-card-content>
                  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                      <div>
                        <strong class="noMarginHeader">Results ({{trainingFilteredTableData.length}})</strong>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-form-field style="width:200px;">
                          <input (keyup)="filterTrainingTable()" placeholder="Filter Results" [(ngModel)]="trainingFilterString" [ngModelOptions]="{standalone: true}" matInput />
                        </mat-form-field>
                      </div>
                    </div>
                    <br />
                    <mat-table [dataSource]="trainingDataSource" matSort #TrainingTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                      <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="trainingTableColumns"></mat-header-row>
                      <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: trainingTableColumns"></mat-row>
                      <ng-container *ngFor="let cellData of trainingTableFormat" [matColumnDef]="cellData.columnName">
                        <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size">{{ cellData.type === 'date' ? (row[cellData.columnName] | date:'MM/dd/yyyy') : displayLimit(row[cellData.columnName], '80') }}</mat-cell>
                      </ng-container>
                    </mat-table>
                    <br />
                    <mat-paginator [pageSize]="trainingTablePageSize" [pageSizeOptions]="[5, 10, 50, trainingFilteredTableData.length]" #TrainingTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{uiData.firm.icon}}</mat-icon> &nbsp; Affiliations ({{personFilteredAffiliations.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <span fxFlex>Affiliations</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                      <div fxLayout="column">
                        <strong class="noMarginHeader">Results ({{personFilteredAffiliations.length}})</strong>
                        <div fxLayout="row">
                          <mat-form-field style="width:200px;">
                            <input placeholder="Filter Results" type="text" [(ngModel)]="affiliationFilterString" [ngModelOptions]="{standalone: true}" (input)="filterAffiliationTable()" matInput />
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <button mat-raised-button color="primary" (click)="openAddAffiliationDialog()">
                          <mat-icon>add</mat-icon> Add Affiliation
                        </button>
                      </div>
                    </div>
                    <br />
                    <mat-table [dataSource]="affiliationDataSource" matSort #AffiliationTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                      <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="affiliationTable.layout.columns.concat('actions')"></mat-header-row>
                      <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: affiliationTable.layout.columns.concat('actions')" [ngClass]="getAffiliationRowClass(row)"></mat-row>
                      <ng-container *ngFor="let cellData of affiliationTable.layout.container" [matColumnDef]="cellData.columnName">
                        <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" [ngClass]="cellData.columnName === 'status' ? getAffiliationStatusClass(row) : ''">
                          <ng-container *ngIf="cellData.columnName !== 'status'">
                            {{ displayLimit(row[cellData.columnName], cellData.size) }}
                          </ng-container>
                          <ng-container *ngIf="cellData.columnName === 'status'">
                            {{ getAffiliationStatus(row) }}
                          </ng-container>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef fxFlex="15" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Actions</mat-header-cell>
                        <mat-cell *matCellDef="let row" fxFlex="15" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
                          <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <span><strong>Action: </strong></span>
                            <button mat-raised-button color="warn" style="width: 90px;" aria-label="Delete affiliation" matTooltip="Delete affiliation" [disabled]="!canDeleteAffiliation(row)" (click)="deleteAffiliation(row); $event.stopPropagation()">Delete</button>
                          </div>
                          <div fxLayout="row" fxLayoutGap="2px" *ngIf="!isMobile">
                            <button mat-icon-button color="warn" aria-label="Delete affiliation" matTooltip="Delete affiliation" [disabled]="!canDeleteAffiliation(row)" (click)="deleteAffiliation(row); $event.stopPropagation()">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </mat-cell>
                      </ng-container>
                    </mat-table>
                    <br />
                    <mat-paginator [pageSize]="affiliationTablePageSize" [pageSizeOptions]="[5, 10, 50, personFilteredAffiliations.length]" #AffiliationTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon>{{'manage_accounts'}}</mat-icon> &nbsp; User Accounts ({{userAccounts.length}})
            </ng-template>
            <ng-container>
              <mat-card class="custom-mat-card">
                <mat-card-title>
                  <div fxLayout="row">
                    <span>User Accounts</span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  <div fxLayout="column">
                    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                      <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                        <div fxLayoutGap="5px">
                          <strong class="noMarginHeader">Results ({{userAccounts.length}})</strong>
                          <mat-form-field style="width:200px;">
                            <input (keyup)="applyUserAccountFilter($event)" placeholder="Filter Results" matInput />
                          </mat-form-field>
                        </div>
                      </div>

                      <br />

                      <mat-table [dataSource]="userAccountsDataSource" matSort #UserAccountTableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
                        <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="userAccountTable.layout.columns"></mat-header-row>
                        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: userAccountTable.layout.columns" title="User Account" [ngClass]="getRowClass(row)"></mat-row>

                        <ng-container *ngFor="let cellData of userAccountTable.layout.container" [matColumnDef]="cellData.columnName">
                          <mat-header-cell mat-sort-header [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{row[cellData.columnName]}}">
                            <ng-container [ngSwitch]="cellData.type">
                              <ng-container *ngSwitchCase="'date'">
                                {{ row[cellData.columnName] | date: 'MM/dd/yyyy' }}
                              </ng-container>
                              <ng-container *ngSwitchCase="'bool'">
                                <mat-checkbox [checked]="row[cellData.columnName]" disabled></mat-checkbox>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <ng-container *ngIf="cellData.columnName === 'lastUpdatedBy'">
                                  {{ shouldShowRequestedBy(row) ? displayLimit(row[cellData.columnName], cellData.size) : '' }}
                                </ng-container>
                                <ng-container *ngIf="cellData.columnName !== 'lastUpdatedBy'">
                                  {{ displayLimit(row[cellData.columnName], cellData.size) }}
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <mat-header-cell *matHeaderCellDef fxFlex="7">Actions</mat-header-cell>
                          <mat-cell *matCellDef="let row" fxFlex="7">
                            <div style="display: flex; justify-content: space-between; width: 100px;">
                              <button mat-icon-button [color]="row.requestedStatus === 'Active' ? 'primary' : 'warn'" style="width: 50px;" (click)="toggleUserAccountRequestedStatus(row); $event.stopPropagation()" [title]="row.requestedStatus === 'Active' ? 'Request Deactivation' : 'Request Activation'">
                                <mat-icon>{{row.requestedStatus === 'Active' ? 'toggle_on' : 'toggle_off'}}</mat-icon>
                              </button>
                            </div>
                          </mat-cell>
                        </ng-container>
                      </mat-table>

                      <br />
                      <mat-paginator [pageSize]="userAccountTablePageSize" [pageSizeOptions]="[5, 10, 50, userAccountTable.layout.data.length]" #UserAccountTablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </mat-tab>

        </mat-tab-group>
      </mat-card>
    </div>
  </div>

  <mat-card class="dialog-footer-card" [style.background-color]="uiData.individual.color">
    <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="saveChanges()" [disabled]="saving">Save Changes</button>
    <button mat-raised-button (click)="exitComponent()">Exit</button>
  </mat-card>
</div>